import React, { useEffect, useState } from "react";
import {
  useTheme,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Tabs,
  Tab,
  Box,
  Button,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Skeleton
} from "@mui/material";
import Fade from '@mui/material/Fade';
import { tokens } from "../theme";
import axios from "axios";
import Cookies from "js-cookie";
import Header from "../Components/Header";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import useMediaQuery from "@mui/material/useMediaQuery";
import Tooltip from '@mui/material/Tooltip';
import baseURL from "../config";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import SearchIcon from '@mui/icons-material/Search';
import CryptoJS from "crypto-js";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import RecordsTable from "../Components/RecordsTable";

const PointScore = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [filteredPointScoreData, setFilteredPointScoreData] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedPointScore, setSelectedPointScore] = useState(null);
  const isNonMobile = useMediaQuery("(min-width:620px)");
  const [isLoading, setIsLoading] = useState(true);
  const [pointScoreData, setPointScoreData] = useState({
    pointScoreId: 0,
    startDate: "",
    endDate: "",
    euro: 0.0,
    isActive: false
  });
  const [tabValue, setTabValue] = useState(0);
  const getDecryptedToken = () => {
    const encryptedToken = Cookies.get("token");
    if (!encryptedToken) return null;

    const secretKey = '19092002'; 
    const bytes = CryptoJS.AES.decrypt(encryptedToken, secretKey);
    const decryptedToken = bytes.toString(CryptoJS.enc.Utf8);

    return decryptedToken || null;
  };

 
  const token = getDecryptedToken();
  const [searchQuery, setSearchQuery] = useState("");

  const fetchPointScores = async () => {
    try {
      const response = await axios.get(`${baseURL}/api/PointScore/GetAllPointScore`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data.success) {
        const ps = response.data.message;
        setIsLoading(false);
        setFilteredPointScoreData(ps);
      } else {
        toast.error("Failed to fetch point score: Success flag is false.");
      }
    } catch (error) {
      toast.error(`Error fetching point score data: ${error.message}`);
    }
  };


  useEffect(() => {
    fetchPointScores();
  }, []);

  
  const fetchPointScore = async (pointId) => {
    try {
      const response = await axios.get(`${baseURL}/api/PointScore/GetPointSById`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { id: pointId },
      });
      if (response.data.success) {
        setPointScoreData(response.data.message);
        setDialogOpen(true);
      } else {
        toast.error("Failed to fetch point score: Success flag is false.");
      }
    } catch (error) {
      toast.error(`Error fetching point score: ${error.message}`);
    }
  };


  const handleEdit = (event) => {
    const { name, value } = event.target;
    setPointScoreData((prevData) => ({ ...prevData, [name]: value }));
  };


  const handleSave = async () => {
    if (!pointScoreData.euro || !pointScoreData.startDate || !pointScoreData.endDate) {
      toast.error("Please fill in all fields.");
      return;
    }

    try {
      const response = await axios.post(
        `${baseURL}/api/PointScore/UpdatePointScore`,
        pointScoreData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.data.success) {
        
        
        toast.success("Point Score u përditësua me sukses!");
        await fetchPointScores();
        setDialogOpen(false);
      } else {
        toast.error("Failed to update point score.");
      }
    } catch (error) {
      toast.error(`Error updating point score: ${error.message}`);
    }
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  }
  const filteredData = filteredPointScoreData.filter((ps) => {
    const euro = ps.euro.toString() || ""; 
    const startDate = ps.startDate?.toLowerCase() || ""; 
    const endDate = ps.endDate?.toLowerCase() || ""; 
  
    return (
        euro.includes(searchQuery) ||
      startDate.includes(searchQuery) ||
      endDate.includes(searchQuery)
    );
  });
  

  const desktopColumns = [
    {
      field: "pointScoreId",
      headerName: "ID",
      flex: 0.35,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => <span className="table-muted">#{params.value}</span>,
    },
    {
      field: "startDate",
      headerName: "Start",
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => <span className="table-muted">{params.value ? new Date(params.value).toLocaleDateString() : "N/A"}</span>,
    },
    {
      field: "endDate",
      headerName: "End",
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => <span className="table-muted">{params.value ? new Date(params.value).toLocaleDateString() : "N/A"}</span>,
    },
    {
      field: "euro",
      headerName: "Euro",
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => <span className="table-strong">{Number(params.value || 0).toFixed(2)} €</span>,
    },
    {
      field: "isActive",
      headerName: "Status",
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => (
        <span className={`table-pill ${params.value ? "success" : "danger"}`}>
          {params.value ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      field: "Actions",
      headerName: "",
      headerClassName: 'super-app-theme--header',
      flex: 0.35,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <IconButton
          onClick={() => fetchPointScore(params.row.pointScoreId)}
          className="table-action-button"
          aria-label="Edit point score"
        >
          <DriveFileRenameOutlineIcon />
        </IconButton>
      ),
    },
  ];

  const mobileColumns = [
    {
      field: "euro",
      headerName: "Euro",
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => <span className="table-strong">{Number(params.value || 0).toFixed(2)} €</span>,
    },
    {
      field: "isActive",
      headerName: "Status",
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => (
        <span className={`table-pill ${params.value ? "success" : "danger"}`}>
          {params.value ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      field: "Actions",
      headerName: "",
      headerClassName: 'super-app-theme--header',
      flex: 0.45,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <IconButton
          onClick={() => fetchPointScore(params.row.pointScoreId)}
          className="table-action-button"
          aria-label="Edit point score"
        >
          <DriveFileRenameOutlineIcon />
        </IconButton>
      ),
    },
  ];

  const columns = isNonMobile ? desktopColumns : mobileColumns
  return (
    <Box m="10px">
      <Header title="Vlerat e pikeve" subtitle="Detajet e pikeve" />
      <ToastContainer />
      <Box mb={2} display="flex" justifyContent="flex-start">
        <TextField
          label="Search"
          variant="outlined"
          onChange={handleSearch}
          sx={{ backgroundColor: colors.primary[600], width: isNonMobile ? "30%" : "50%" }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />

      </Box>
        
      <Box
        m="10px 0 0 0"
        sx={{
          "& .MuiDataGrid-root": { border: "none" },
          "& .MuiDataGrid-cell": { borderBottom: "none" },
          "& .name-column--cell": { color: "#3b0a45" },
          "& .MuiDataGrid-columnHeaders": {
           background: "black",
            borderBottom: "none",
             color: "#ffffff"
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[500],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.primary[800],
            color: "#ffffff"
           
          },
          "& .MuiButton-root": { color: "#ffffff" },
          "& .super-app-theme--header": {
            backgroundColor: colors.primary[200],
          },
          "& .MuiToolbar-root":{color :"#ffffff"},
          "&. MuiTablePagination-actions": {color: "white"}

        }}
      >
      <div style={{ width: "100%" }}>

      {isLoading ? (
         
         <Skeleton
           variant="rectangular"
           width="100%"
           height={500}
           animation="wave"
         />
       ) : (
        <RecordsTable
          columns={columns}
          rows={filteredData}
          getRowId={(row) => row.pointScoreId}
          onRowDoubleClick={(params) => fetchPointScore(params.row.pointScoreId)} 
          emptyMessage="No point values match your search."
        />
       )}
     </div>
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
      
        <DialogContent
            className="custom-dialog-size"
            sx={{ backgroundColor: colors.primary[500], height: isNonMobile ? "" : "50vh",}}
          >
            <div className="tabs-container">
                <Tabs
                  variant="scrollable"
                  scrollButtons="auto"
                  value = {tabValue}  
                >
                  <Tab
                    label="Info per Piket"
                    sx={{
                      color: "white",
                      backgroundColor: colors.primary[900],
                      margin: "2px",
                      borderRadius: "5px",
                  
                    }}
                  />
                  </Tabs>
              </div>
              <div
                    style={{
                      margin: "10px",
                      textAlign: "center",
                      display: isNonMobile ? undefined : "flex",
                      flexDirection: isNonMobile ? "row" : "column",
                    }}
                  >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                        label="Start Date"
                        value={pointScoreData.startDate ? dayjs(pointScoreData.startDate) : null}
                        onChange={(newValue) => {
                        setPointScoreData((prevData) => ({
                            ...prevData,
                            startDate: newValue ? newValue.toISOString() : ""
                        }));
                        }}
                        renderInput={(params) => (
                        <TextField
                            {...params}
                            fullWidth
                            margin="dense"
                            variant="outlined"
                        />
                        )}
                    />
                    </LocalizationProvider>

                    <LocalizationProvider dateAdapter={AdapterDayjs} >
                    <DateTimePicker
                        label="End Date"
                        
                        value={pointScoreData.endDate ? dayjs(pointScoreData.endDate) : null}
                        onChange={(newValue) => {
                        setPointScoreData((prevData) => ({
                            ...prevData,
                            endDate: newValue ? newValue.toISOString() : ""
                        }));
                        }}
                        renderInput={(params) => (
                        <TextField
                            {...params}
                            fullWidth
                            margin="dense"
                            variant="outlined"
                       
                        />
                        )}
                    />
             </LocalizationProvider>
            {/* <TextField
              label="Start Date"
              name="startDate"
              value={pointScoreData.startDate}
              onChange={handleEdit}
              fullWidth
              margin="dense"
            />
            <TextField
              label="End Date"
              name="endDate"
              value={pointScoreData.endDate}
              onChange={handleEdit}
              fullWidth
              margin="dense"
            /> */}
            <TextField
              label="Euro"
              name="euro"
              value={pointScoreData.euro}
              onChange={handleEdit}
              fullWidth
              margin="dense"
            />
                    
            <FormControl margin="dense">
                <InputLabel id="is-active-label">Is Active</InputLabel>
                <Select
                labelId="is-active-label"
                name="isActive"
                value={pointScoreData.isActive}
                onChange={handleEdit}
                >
                <MenuItem value={true}>True</MenuItem>
                <MenuItem value={false}>False</MenuItem>
                </Select>
            </FormControl>
                        
          </div>
        <DialogActions className="custom-dialog-background">
                <Button
                  onClick={() => setDialogOpen(false)}
                  sx={{ backgroundColor: "white" }}
                  >
                  Cancel
                </Button>
                <Button
                  onClick={handleSave}
                  sx={{ backgroundColor: "white" }}
                  >
                  Save
                </Button>
              </DialogActions>
               </DialogContent>    
                </Dialog>
      </Box>
    </Box>
  );
};

export default PointScore;
